module.exports = __webpack_public_path__ + "ebeaf798c06e50e04825f273c4761dd5.png";